import React from 'react';

interface ConsoleLogProps {
    messages: string[];
}

const ConsoleLog: React.FC<ConsoleLogProps> = ({ messages }) => {
    return (
        <div className="w-full max-w-7xl mx-auto mt-4 p-4 bg-gray-900 rounded-lg text-green-400 h-32 overflow-y-auto text-sm">
            {messages.map((msg, idx) => (
                <div key={idx}>{msg}</div>
            ))}
        </div>
    );
};

export default ConsoleLog;
